module.exports = __webpack_public_path__ + "static/media/ai.9908a511.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/ai.jpg
// module id = 45
// module chunks = 0